import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isEmailAddress } from "../../Util/Util/validations.js";
const Email = ({
  id = "email",
  "data-t": dataT = "email",
  label,
  errorMessage,
  validations = [isEmailAddress],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id,
    "data-t": dataT,
    type: "email",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  Email as default
};
//# sourceMappingURL=Email.js.map
